import type { JSX, FC } from 'react';

import type { RegisterDialogData } from '../../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { HNHelseregistreJS } from '../../../../types/Resources';

import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import { shortDateNumbers } from '@helsenorge/core-utils/date-fns-utils';
import SafeHTML from '@helsenorge/framework-utils/components/safe-html';

import { getDialogTypeBeskrivelse } from '../utils';

interface Props {
  dialogTypes: RegisterDialogData[] | null;
  resources: HNHelseregistreJS;
}

export const BestillingerStatus: FC<Props> = ({ dialogTypes, resources }): JSX.Element => {
  let bestillingHarFeilet = false;

  const blokkerteDialoger =
    dialogTypes &&
    dialogTypes.reduce((blokkerte: JSX.Element[], dialog: RegisterDialogData) => {
      if (dialog.blokkert) {
        blokkerte.push(
          <li key={`${dialog.dialogType}-${dialog.forespurtTid}`}>
            <strong>{getDialogTypeBeskrivelse(dialog.dialogType, resources)}</strong>
            {dialog.forespurtTid ? ` (${shortDateNumbers(new Date(dialog.forespurtTid))})` : ''}
          </li>
        );
      }

      if (dialog.feilet) {
        bestillingHarFeilet = true;
      }
      return blokkerte;
    }, []);

  return (
    <>
      {blokkerteDialoger && blokkerteDialoger.length > 0 && (
        <>
          <Spacer />
          <NotificationPanel label={resources.bestillingPaaVentMessage}>
            {[<ul key={0}>{blokkerteDialoger}</ul>]}
            <SafeHTML html={resources.bestillingPaaVentMessageBody} tagName="span" />
          </NotificationPanel>
          <Spacer />
        </>
      )}
      {bestillingHarFeilet && (
        <>
          <Spacer />
          <NotificationPanel variant="error">{resources.bestillInnsyn_Error_Body}</NotificationPanel>
          <Spacer />
        </>
      )}
    </>
  );
};
